import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";
import { isUuid } from "data/uuid";

export const experienceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createExperience: builder.mutation({
      query: (experience) => ({
        url: API_PREFIX + "/experience/create",
        method: "POST",
        body: experience,
      }),
      invalidatesTags: ["experience", "ExperiencesList"],
    }),
    getExperience: builder.query({
      query: (id) => ({
        url:
          API_PREFIX +
          (isUuid(id)
            ? `/experience/single/${id}`
            : `/experience/single/by-slug/${id}`),
        method: "GET",
      }),
      transformResponse: (response) => ({
        experience: {
          ...response.experience,
        },
        host: {
          ...response.experience.host,
        },
      }),
      providesTags: ["experience", "EditingExperience"],
    }),
    getExperienceMultiple: builder.query({
      query: (uuids) => ({
        url: API_PREFIX + `/experience/multiple`,
        body: { experience_uuids: uuids },
        method: "POST",
      }),
      transformResponse: (response) => ({
        experience: {
          ...response.experience,
        },
      }),
      providesTags: ["experience", "EditingExperience"],
    }),
    uploadExperienceCover: builder.mutation({
      query: (formData) => ({
        url: API_PREFIX + "/experience/upload/cover",
        method: "POST",
        body: formData,
      }),
    }),
    uploadExperienceAlbumImage: builder.mutation({
      query: (formData) => ({
        url: API_PREFIX + "/experience/upload/album-image",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["experience"],
    }),
    editExperience: builder.mutation({
      query: (experience) => ({
        url: API_PREFIX + "/experience/edit",
        method: "PUT",
        body: experience,
      }),
      invalidatesTags: ["EditingExperience"],
    }),
    getExperiencesNearby: builder.query({
      query: (coords) => ({
        url:
          API_PREFIX +
          `/experience/nearby/${coords.latitude}/${coords.longitude}/${coords.radius}`,
        method: "GET",
      }),
      providesTags: ["ExperiencesList"],
    }),
    filterExperience: builder.query({
      query: (filter) => ({
        url: API_PREFIX + `/experience/filter/`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["ExperiencesList"],
    }),
    getExperienceByCity: builder.query({
      query: (filter) => ({
        url: API_PREFIX + `/experience/byCity/`,
        method: "POST",
        body: filter,
      }),
      providesTags: ["ExperiencesList"],
    }),
    getExperienceTimeSlots: builder.query({
      query: (availability) => ({
        url: API_PREFIX + `/experience/timeslots/`,
        method: "POST",
        body: availability,
      }),
      providesTags: ["ExperiencesList"],
    }),
    getExperiencesByHostUUID: builder.query({
      query: (host_uuid) => ({
        url: API_PREFIX + `/experience/host/${host_uuid}`,
        method: "GET",
      }),
      providesTags: ["ExperiencesList"],
    }),

    duplicateExperience: builder.mutation({
      query: (arg) => {
        const experience_uuid = typeof arg === "string" ? arg : arg?.experience_uuid;
        return {
          url: API_PREFIX + `/experience/duplicate/${experience_uuid}`,
          method: "POST",
          body: {},
        };
      },
      invalidatesTags: ["experience", "EditingExperience", "ExperiencesList"],
    }),
  }),
});

export const {
  useCreateExperienceMutation,
  useUploadExperienceCoverMutation,
  useUploadExperienceAlbumImageMutation,
  useLazyGetExperienceQuery,
  useGetExperienceQuery,
  useGetExperienceMultipleQuery,
  useLazyGetExperienceMultipleQuery,
  useEditExperienceMutation,
  useGetExperiencesNearbyQuery,
  useLazyGetExperiencesNearbyQuery,
  useFilterExperienceQuery,
  useLazyFilterExperienceQuery,
  useGetExperienceByCityQuery,
  useLazyGetExperienceByCityQuery,
  useGetExperienceTimeSlotsQuery,
  useLazyGetExperienceTimeSlotsQuery,
  useGetExperiencesByHostUUIDQuery,
  useDuplicateExperienceMutation,
} = experienceApiSlice;
